import { Form as VeeForm, Field, configure, defineRule } from 'vee-validate'
import { required, confirmed, email } from '@vee-validate/rules'

const VeeValidateComponents = [
  {
    name: "VeeForm",
    component: VeeForm
  },
  {
    name: "Field",
    component: Field
  }
]

defineRule('required', required)
defineRule('confirmed', confirmed)
defineRule('email', email)

configure({
  generateMessage: context => {
    switch (context.rule.name) {
      case 'required':
        return `The ${context.field} field is required`
      case 'confirmed':
        return "Confirm Password: Please enter the same value again"
      case 'email':
        return `The ${context.field} field must be a valid email`
    }
  }
})

export default VeeValidateComponents